import { render, staticRenderFns } from "./MainIndex.vue?vue&type=template&id=62434ec3&"
import script from "./MainIndex.vue?vue&type=script&lang=js&"
export * from "./MainIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports